import { Route, Switch, Redirect } from "react-router-dom";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import theme from "assets/theme";
import { routes } from "constants/routes";
import { PrivateRoute } from "private-route";
import { useEffect } from "react";
import { vars } from "./services/constants";
import { SnackbarProvider } from "./context/SnackbarContext";
import { Snackbar } from "./modules/dashboard/components/snack-barV2.component";

export function App() {
  useEffect(() => {
    document.title = vars.title

    const faviconLink = document.createElement('link');
    faviconLink.rel = 'shortcut icon';
    faviconLink.href = vars.productFaviconImgUrl;

    const head = document.head || document.getElementsByTagName('head')[0];
    head.appendChild(faviconLink);
  }, [])
  
  return (
    <ThemeProvider theme={theme}>
      <SnackbarProvider>
        <CssBaseline />
        <Switch>
          {routes.map((route) => {
            if (!route.ibTypesAllowed) {
              return <Route path={route.route} key={route.key} component={route.component} />;
            }
            return (
              <PrivateRoute
                exact
                path={route.route}
                component={route.component}
                ibTypesAllowed={route.ibTypesAllowed}
                key={route.key}
              />
            );
          })}
          <Redirect from="*" to="/authentication/sign-in" />
        </Switch>
        <Snackbar />
      </SnackbarProvider>
    </ThemeProvider>
  );
}
